import { useEffect, useState } from "react";

import { AuthState } from "@snapchat/sso-auth";

import { useSnapSSOAuthService } from "./useSnapSSOAuthService";

export const useAuthState = (redirectReferrer?: string): AuthState => {
    const [authState, setAuthState] = useState<AuthState>(AuthState.Unknown);
    const snapSSOAuthService = useSnapSSOAuthService();

    useEffect(() => {
        const subscription = snapSSOAuthService.getAuthStateAsObservable().subscribe(setAuthState);
        return () => {
            subscription.unsubscribe();
        };
    }, [snapSSOAuthService]);

    useEffect(() => {
        switch (authState) {
            case AuthState.NonAuthenticated:
                snapSSOAuthService.redirectToAccountsServer(redirectReferrer);
                break;
            case AuthState.Unknown:
                void snapSSOAuthService.tryAuthenticate();
                break;
        }
    }, [authState, snapSSOAuthService, redirectReferrer]);

    return authState;
};
